'use client';

import type { ReactNode } from 'react';

import BanxaModal from '@shared/common/components/modals/BanxaModal';
import ConnectAndSignModal from '@shared/common/components/modals/ConnectAndSignModal';
import CustomContentModal from '@shared/common/components/modals/CustomContentModal';
import SupportModal from '@shared/common/components/modals/SupportModal';

const GlobalModalsLaunchpad = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {children}
      <ConnectAndSignModal />
      <BanxaModal />
      <CustomContentModal />
      <SupportModal />
    </>
  );
};

export default GlobalModalsLaunchpad;
